import FieldSequenceControl from './StageSequenceControl';

export default {
  mixins: [
    FieldSequenceControl,
  ],
  methods: {
    copyField(campoBase, listaCampos) {
      console.log(campoBase)
      console.log(listaCampos)
      let campoNovo = {
        active: campoBase.active,
        allowComments: campoBase.allowComments,
        allowsViewDataFromPreviousSteps: campoBase.allowsViewDataFromPreviousSteps,
        displayName: campoBase.displayName,
        sequenceNumber: this.getNextSequenceNumber(listaCampos),
        scriptPython: campoBase.scriptPython,
        validationScript: campoBase.validationScript,
        field: [],
        nextStage: [],
        canView: [],
        simpleOperator: [],
        advancedOperator: [],
      };

      listaCampos.push(campoNovo);

      this.getSortedList(campoBase.field).forEach(valorTemp => {
        this.copyProcessField(valorTemp, campoNovo.field);
      });
      campoBase.canView.forEach(valorTemp => {
        this.copyPermission(valorTemp, campoNovo.canView);
      });
      campoBase.simpleOperator.forEach(valorTemp => {
        this.copyPermission(valorTemp, campoNovo.simpleOperator);
      });
      campoBase.advancedOperator.forEach(valorTemp => {
        this.copyPermission(valorTemp, campoNovo.advancedOperator);
      });

    },
    copyProcessField(campoBase, listaCampos) {
      console.log(campoBase);
      console.log(listaCampos);
      let campoNovo = {
        active: campoBase.active,
        sequenceNumber: this.getNextSequenceNumber(listaCampos),
        required: campoBase.required,
        type: campoBase.type,
        displayName: campoBase.displayName,
        tip: campoBase.tip,
        uniqueKey: campoBase.uniqueKey,
        visibility: campoBase.visibility,
        values: [],
        allowAttachment: false,
        isMandatoryAttachment: false,
      };
      listaCampos.push(campoNovo);

      this.getSortedList(campoBase.values).forEach(valorTemp => {
        this.copyValue(valorTemp, campoNovo.values);
      });

    },
    copyValue(valorBase, listaValores) {
      let valorNovo = {
        active: valorBase.active,
        sequenceNumber: this.getNextSequenceNumber(listaValores),
        value: valorBase.value,
        hasAdditionalField: valorBase.hasAdditionalField,
        additionalField: [],
      };

      listaValores.push(valorNovo);

      this.getSortedList(valorBase.additionalField).forEach(campoAddTemp => {
        this.copyProcessField(campoAddTemp, valorNovo.additionalField);
      });
    },
    copyPermission(permissionBase, listaPermission) {
      let canView = {
        value: permissionBase.value,
        text: permissionBase.text
      }
      listaPermission.push(canView);
    },
    copynextStage(nextStageBase, nextStages)
    {
      let field = {

      }
    }
  }
}

